import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function WhyItMatters() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8
  }} className="py-16 lg:py-24 border-t border-[#1B6B3A]/10" data-id="element-214">
      <h2 className="text-3xl lg:text-4xl font-serif font-bold text-[#1A1A1A] mb-8 lg:mb-10" data-id="element-215">
        Why this matters (especially if you're cash-tight)
      </h2>

      <p className="text-lg lg:text-xl leading-relaxed lg:leading-loose mb-8 lg:mb-10 text-[#3D3D3D]" data-id="element-216">
        When your cash-to-close jumps late, it forces bad decisions:
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-5 mb-10 lg:mb-14" data-id="element-217">
        {['High-interest quick loans', 'Asking family last minute', 'Delaying closing (and paying more)', 'Wiring mistakes under stress'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-red-50 p-4 lg:p-5 rounded-lg border border-red-100" data-id="element-218">
            <AlertTriangle className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-219" />
            <span className="text-base lg:text-lg text-[#3D3D3D]" data-id="element-220">{item}</span>
          </div>)}
      </div>

      <p className="text-xl lg:text-2xl font-medium text-[#1A1A1A] border-l-4 border-[#1B6B3A] pl-6 lg:pl-8 py-2 leading-relaxed" data-id="element-221">
        This system reduces those moments because you learn about changes{' '}
        <span className="text-[#1B6B3A] font-bold" data-id="element-222">
          when you still have options
        </span>
        .
      </p>
    </motion.section>;
}